import { EMPTY_STRING } from '../../constants/common'
import { REQUEST_STATUS } from '../../constants/request'

export function getIsRequestArchiveBlockedByStatus({ statusId, ukConfig }) {
  const availableStatuses =
    ukConfig?.request_available_statuses_for_manual_archive

  return (
    Number.isFinite(statusId) &&
    Boolean(availableStatuses) &&
    !availableStatuses.includes(statusId)
  )
}

export function getRequestArchiveBlockedByStatusTooltipValues(t, statusId) {
  const statusTextKey = REQUEST_STATUS[statusId]?.text

  return { status: statusTextKey ? t(statusTextKey) : EMPTY_STRING }
}

export function getRequestArchiveBlockedByStatusTooltip(t, statusId) {
  return t(
    'Request.ArchiveBlockedByStatusTooltipKey',
    getRequestArchiveBlockedByStatusTooltipValues(t, statusId)
  )
}

export function getRequestArchiveBlockedByStatusTooltipProps({
  isBlocked,
  statusId,
  t,
}) {
  return isBlocked
    ? {
        tooltipContent: 'Request.ArchiveBlockedByStatusTooltipKey',
        tooltipContentValues: getRequestArchiveBlockedByStatusTooltipValues(
          t,
          statusId
        ),
      }
    : null
}
